import { z } from 'zod';
import { defineEndpoint } from '../define';
import { ReleaseProductSchema } from './shapes';

export const ListReleaseProductsResponseSchema = z.object({
  data: z.array(ReleaseProductSchema),
});

export const listReleaseProducts = defineEndpoint({
  method: 'GET',
  path: '/v1/release-products',
  params: z.object({}),
  // Disabled products are excluded by default; config surfaces opt in to manage them.
  query: z.object({ includeDisabled: z.literal('true').optional() }),
  body: z.undefined(),
  response: ListReleaseProductsResponseSchema,
});
